import React from "react";
import { Typography, styled, Paper, Box, Button } from "@material-ui/core";
import { useHistory } from "react-router-dom";

const CustomPaper = styled(Paper)({
  display: "flex",
  flexDirection: "row",
  justifyContent: "center",
  alignItems: "center",
  margin: "0",
  height: "100vh",
});

const CustomBox = styled(Box)({
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
  width: "25%",
  height: "25%",
  boxShadow: "0px 0px 10px rgba(0, 0, 0, 0.2)",
  border: "1px",
  borderRadius: "8px",
  padding: "2%",
  "@media (max-width: 600px)": {
    width: "90%",
    height: "70%",
  },
});

const CustomButton = styled(Button)({
  marginTop: "5%",
});

export const PasswordResetCompleteScreen = () => {
  const history = useHistory();

  return (
    <CustomPaper elevation={2}>
      <CustomBox textAlign="center">
        <Typography variant="h5">Password Reset Complete</Typography>
        <Typography variant="body1" paragraph>
          Your account password has been successfully reset.
        </Typography>
        <Typography variant="body1" paragraph>
          You can now log in with your new password.
        </Typography>
        <CustomButton
          variant="contained"
          color="primary"
          fullWidth
          onClick={() => history.push("/")} // Change to your desired route
        >
          Log In
        </CustomButton>
      </CustomBox>
    </CustomPaper>
  );
};
